import type { ComponentPropsWithoutRef } from "react";

export const InvizaLogo = ({
  className,
  ...props
}: ComponentPropsWithoutRef<"svg">) => (
  <svg
    width="142"
    height="143"
    viewBox="0 0 142 143"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <g clipPath="url(#clip0_1212_17)">
      <path
        d="M70.835 142.334C109.956 142.334 141.67 110.621 141.67 71.4996C141.67 32.3786 109.956 0.664795 70.835 0.664795C31.7139 0.664795 0 32.3786 0 71.4996C0 110.621 31.7139 142.334 70.835 142.334Z"
        fill="url(#paint0_radial_1212_17)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M70.8345 11.2905C104.067 11.2905 131.046 38.2687 131.046 71.4979C131.046 104.731 104.067 131.709 70.8345 131.709C37.6052 131.709 10.627 104.731 10.627 71.4979C10.627 38.2687 37.6052 11.2905 70.8345 11.2905ZM70.8345 14.6006C102.237 14.6006 127.736 40.0953 127.736 71.4979C127.736 102.9 102.237 128.395 70.8345 128.395C39.4318 128.395 13.937 102.9 13.937 71.4979C13.937 40.0953 39.4318 14.6006 70.8345 14.6006Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M70.833 25.4576C96.2464 25.4576 116.877 46.088 116.877 71.4985C116.877 96.9119 96.2464 117.542 70.833 117.542C45.4224 117.542 24.792 96.9119 24.792 71.4985C24.792 46.088 45.4224 25.4576 70.833 25.4576ZM70.833 28.6802C94.4658 28.6802 113.654 47.8658 113.654 71.4985C113.654 95.1313 94.4658 114.32 70.833 114.32C47.2002 114.32 28.0145 95.1313 28.0145 71.4985C28.0145 47.8658 47.2002 28.6802 70.833 28.6802Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M82.2213 42.9095C94.1978 47.4967 102.71 59.1059 102.71 72.6878C102.71 90.2805 88.4273 104.563 70.8347 104.563C53.2422 104.563 38.959 90.2805 38.959 72.6878C38.959 59.0816 47.5028 47.4548 59.5133 42.8845V51.6303C52.0229 55.6693 46.9279 63.5883 46.9279 72.6878C46.9279 85.8823 57.6402 96.5944 70.8347 96.5944C84.0293 96.5944 94.7415 85.8823 94.7415 72.6878C94.7415 63.6147 89.676 55.7152 82.2213 51.6655V42.9095Z"
        fill="white"
      />
      <path d="M75.206 38.4341H66.4629V71.4986H75.206V38.4341Z" fill="white" />
    </g>
    <defs>
      <radialGradient
        id="paint0_radial_1212_17"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(70.835 71.4996) scale(70.835 70.8348)"
      >
        <stop stopColor="#003967" />
        <stop offset="0.58" stopColor="#004278" />
        <stop offset="0.8" stopColor="#01569D" />
        <stop offset="1" stopColor="#016AC0" />
      </radialGradient>
      <clipPath id="clip0_1212_17">
        <rect
          width="141.67"
          height="141.67"
          fill="white"
          transform="translate(0 0.664917)"
        />
      </clipPath>
    </defs>
  </svg>
);
